<template>
  <section class="course-content">
    <ContainerMedium>
      <div class="course-content__row">
        <div class="course-content__row__left">
          <CourseTextContent
            v-if="!!courseModuleClass.content"
            :course-class="courseModuleClass"
            class="d-none d-md-block"
          />         
          
          <GenericBox class="mb-4">
            <template #header>Sobre o curso</template>
            <template>{{ course.description }}</template>
          </GenericBox>

          <GenericBox
            v-if="hasMaterials"
            class="mb-4"
          >
            <template #header>Material Complementar</template>

            <template>
              <CourseComplementaryMaterial
                v-for="courseMaterial in courseMaterials"
                :key="courseMaterial.id"
                :course-material="courseMaterial"
              />
            </template>
          </GenericBox>

          <!-- <GenericBox
            v-if="relatedCourses.length"
            class="mb-4"
          >
            <template #header>Cursos Relacionados</template>
            <CourseRelatedCarousel :items="relatedCourses" />
          </GenericBox>         -->

          <CourseGroupBox type="course_class" />
        </div>

        <div class="course-content__row__right">
          <div class="mb-3" v-if="course.is_express">
            <CourseExpressCard />
          </div>

          <aside class="aside">
            <CourseTextContent
              v-if="!!courseModuleClass.content"
              :course-class="courseModuleClass"
              class="d-block d-md-none"
            />

            <div
              v-if="hasCourseAccess"
              class="aside__section"
            >
              <CourseProgressDetails
                :course="course"
              />
            </div>

            <CourseAuthor
              v-for="user in course.authors"
              :key="user.id"
              :user="user"
              class="aside__section"
            />

            <section
              v-if="course.is_certifiable"
              class="aside__section"
            >
              <CourseCertificateBox />
            </section>

            <section class="aside__modules">
              <CourseModules
                v-for="(courseModule, index) in courseModules"
                :key="courseModule.id"
                :course-module="courseModule"
                :index="index + 1"
              />
            </section>
          </aside>
        </div>
      </div>
    </ContainerMedium>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CourseCertificateBox from '@/components/course/CourseCertificateBox'
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'
  import CourseModules from '@/components/course/CourseModules'
  import CourseAuthor from '@/components/course/CourseAuthor'
  import GenericBox from '@/components/boxes/GenericBox'
  import CourseGroupBox from '@/components/group/CourseGroupBox'
  import CourseComplementaryMaterial from '@/components/course/CourseComplementaryMaterial'
  import CourseProgressDetails from '@/components/course/CourseProgressDetails'
  import CourseTextContent from '@/components/course/CourseTextContent'
  import CourseRelatedCarousel from '@/components/course/CourseRelatedCarousel'
  import CourseExpressCard from '@/components/course/CourseExpressCard'
  import { getRelatedCourses } from '@/api/course.api'

  export default {
    components: {
      ContainerMedium,
      CourseModules,
      CourseAuthor,
      GenericBox,
      CourseGroupBox,
      CourseComplementaryMaterial,
      CourseProgressDetails,
      CourseTextContent,
      CourseCertificateBox,
      CourseRelatedCarousel,
      CourseExpressCard,
    },

    data: () => ({
      relatedCourses: [],     
    }),

    computed: {
      ...mapGetters('courseGroup', ['courseGroup']),

      ...mapGetters('course', [
        'course',
        'courseModules',
        'hasCourseAccess',
        'courseMaterials',
        'courseModuleClass'
      ]),
      
      hasMaterials () {
        return this.courseMaterials.length > 0
      }
    },

    async mounted () {    
      // this.isLoading = true
      
      // await this.getPublicCourses()

      // this.isLoading = false
    },

   methods: {  
    async getPublicCourses() {
      const res = await getRelatedCourses(this.course.id)
      this.relatedCourses = res.data
    }
  }

  }
</script>

<style scoped lang="scss">
  .course-content {
    margin-top: 1.25rem;

    &__row {
      display: flex;
      flex-wrap: wrap;
      margin-left: -15px;
      margin-right: -15px;

      & > * {
        padding: 0 15px;
        width: 100%;
      }
    }

    @media (min-width: 1024px) {
      &__row {
        &__left {
          flex: 0 0 60%;
          width: 60%;
        }

        &__right {
          flex: 0 0 40%;
          width: 40%;
        }
      }
    }

    @media (max-width: 1024px) {
      &__row {
        &__left { order: 1 }

        &__right { order: 0 }
      } 
    }
  }

  .aside {
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(#000, .1);
    border-radius: 5px;
    padding: 15px;

    &__section {
      border-bottom: 1px solid rgba(#000, .1);
      margin-bottom: 15px;
      padding-bottom: 15px;
    }

    &__modules > *:not(:last-child) {
      margin-bottom: 10px;
    }

    @media (max-width: 550px) {
      &__section {
        order: 1;
      }
    }
  }
</style>